﻿import React, { useState, useEffect } from 'react';
import { ItemBasicInformation } from '../models/item-basic-information';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import { Button } from 'devextreme-react/button';

export interface Props {
    initInformation?: ItemBasicInformation;
    onOkClick?: () => void;
}

export default function ItemBasicInformationDialog(props: Props) {
    const [information, setInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getItemInformation();
    }, []);

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Row Pointer</div>
                    <div className="pw-readonly-label">{information ?
                        information.rowPointer : ''} <span><i className="dx-icon-copy cursor-pointer" onClick={copyIdToClipboard}></i></span></div>
                </div>
            </div>
            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Create Username</div>
                    <div className="pw-readonly-label">{information ?
                        information.createUsername : ''}</div>
                </div>
            </div>
            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Create Timestamp</div>
                    <div className="pw-readonly-label">{information &&
                        information.createTimestamp ?
                        information.createTimestamp.toString() : ''}</div>
                </div>
                
            </div>
            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Last Modified Username</div>
                    <div className="pw-readonly-label">{information ?
                        information.lastModifiedUsername : ''}</div>
                </div>
            </div>
            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Last Modified Timestamp</div>
                    <div className="pw-readonly-label">{information &&
                        information.lastModifiedTimestamp ?
                        information.lastModifiedTimestamp.toString() : ''}</div>
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button
                        text="OK" type="success"
                        height={'2.6em'}
                        onClick={onOkClick} />

                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onOkClick() {
        if (props.onOkClick)
            props.onOkClick();
    }

    function copyIdToClipboard() {
        if (information && information.rowPointer)
            navigator.clipboard.writeText(information.rowPointer);
    }

    async function getItemInformation() {
        if (props.initInformation) {
            await CrudFunctions.postData("common/itembasicinformation", props.initInformation)
                .then((data) => {
                    setInformation(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Item Information");
                });
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

